import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit, initPage, queryAccountRule } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Recharge = Loadable({
    loader: () => import('./Recharge'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpInternationalRechargeState: state.topUpInternationalRechargeState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange,
          submit,
          initPage,
          queryAccountRule
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/recharge`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Recharge {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
